"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var querystring_1 = __importDefault(require("querystring"));
var debounce_1 = __importDefault(require("lodash/debounce"));
var BaseLayout_1 = __importDefault(require("../app/components/BaseLayout"));
var appMargins_1 = __importDefault(require("../app/components/AppMargins/appMargins"));
var actions_1 = __importDefault(require("./actions"));
var types_1 = require("../app/util/types");
var DirectoryHeader_1 = __importDefault(require("./components/DirectoryHeader"));
var DirectoryResults_1 = __importDefault(require("./components/DirectoryResults"));
var EmptySearchGraphic_1 = __importDefault(require("./components/EmptySearchGraphic"));
var constants_1 = require("./constants");
var ga_1 = require("../app/util/ga");
var useStyles = (0, core_1.makeStyles)(function () {
    return (0, core_1.createStyles)({
        root: {
            height: '100vh',
            overflowY: 'auto',
            zIndex: 1,
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            flexShrink: 0,
            '-ms-flex': '1 1 auto',
        },
    });
});
/**
 * Search query default parameters.
 */
var defaultParams = {
    query: '',
    sortOrder: constants_1.defaultSortOption,
    rowsPerPage: 10,
    currentPage: 0,
    state: '',
    isFile: '',
    isEmail: 'false',
};
/**
 * Redirect back to directory page with parameters that are different from default parameters.
 */
var redirectWithParams = function (newParams, history) {
    var queryObject = { query: newParams.query };
    Object.entries(newParams).map(function (_a, _) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (value && value !== defaultParams[key]) {
            queryObject[key] = value;
        }
        return;
    });
    var newPath = {
        pathname: types_1.DIRECTORY_PAGE,
        search: "".concat(querystring_1.default.stringify(queryObject)),
    };
    history.push(newPath);
};
var updateQueryDebounced = (0, debounce_1.default)(redirectWithParams, 500);
/**
 * @component Directory page root component.
 */
var SearchPage = function () {
    var appMargins = (0, appMargins_1.default)();
    var classes = useStyles({ appMargins: appMargins });
    var dispatch = (0, react_redux_1.useDispatch)();
    var history = (0, react_router_dom_1.useHistory)();
    var location = (0, react_router_dom_1.useLocation)();
    var _a = __read((0, react_1.useState)(''), 2), pendingQuery = _a[0], setPendingQuery = _a[1];
    var _b = __read((0, react_1.useState)(defaultParams.isFile), 2), queryFile = _b[0], setQueryFile = _b[1];
    var _c = __read((0, react_1.useState)(defaultParams.state), 2), querystate = _c[0], setQueryState = _c[1];
    var _d = __read((0, react_1.useState)(defaultParams.isEmail), 2), queryEmail = _d[0], setQueryEmail = _d[1];
    var _e = __read((0, react_1.useState)(defaultParams.sortOrder), 2), queryOrder = _e[0], setQueryOrder = _e[1];
    var _f = __read((0, react_1.useState)(false), 2), disablePagination = _f[0], setDisablePagination = _f[1];
    /**
     * Search parameters that includes the latest changes and retain default values for the others.
     */
    var urlParams = querystring_1.default.parse(location.search.substring(1));
    var params = __assign(__assign({}, defaultParams), urlParams);
    var query = params.query, sortOrder = params.sortOrder, state = params.state, isFile = params.isFile, isEmail = params.isEmail;
    var rowsPerPage = Number(params.rowsPerPage);
    var currentPage = Number(params.currentPage);
    var rankOffset = rowsPerPage * currentPage;
    /** Dispatch action to get new results. */
    var getResults = function () {
        return dispatch(actions_1.default.getDirectoryResults(query, sortOrder, rowsPerPage, currentPage, state, isFile, isEmail));
    };
    var resultsCount = (0, react_redux_1.useSelector)(function (state) { return state.directory.resultsCount; });
    var queryForResult = (0, react_redux_1.useSelector)(function (state) { return state.directory.queryForResult; });
    var searchResults = (0, react_redux_1.useSelector)(function (state) { return state.directory.results; });
    var pageCount = Math.ceil(resultsCount / rowsPerPage);
    var onQueryChange = function (newQuery) {
        setPendingQuery(newQuery);
        updateQueryDebounced(__assign(__assign({}, params), { query: newQuery, state: querystate, isFile: queryFile, isEmail: queryEmail, sortOrder: queryOrder, currentPage: newQuery === params.query
                ? params.currentPage
                : defaultParams.currentPage }), history);
    };
    /** Redirect when sort order, type or state changes. */
    var applyChanges = function () {
        if (!(queryFile === params.isFile) ||
            !(querystate === params.state) ||
            !(queryOrder === params.sortOrder)) {
            redirectWithParams(__assign(__assign({}, params), { state: querystate, isFile: queryFile, sortOrder: queryOrder, isEmail: queryEmail, currentPage: defaultParams.currentPage }), history);
        }
    };
    /** Reset all parameters to default. */
    var onResetFilter = function () {
        // Ensure same differences will not be pushed to history
        if (!(queryFile === defaultParams.isFile) ||
            !(querystate === defaultParams.state) ||
            !(queryOrder === defaultParams.sortOrder)) {
            redirectWithParams(__assign(__assign({}, defaultParams), { query: query, isEmail: queryEmail }), history);
        }
    };
    // Google Analytics
    (0, react_1.useEffect)(function () {
        (0, ga_1.GAEvent)('directory page', 'main');
        (0, ga_1.GAPageView)('DIRECTORY PAGE');
    }, []);
    // Redirect when queryEmail changes
    (0, react_1.useEffect)(function () {
        setPendingQuery('');
        dispatch(actions_1.default.resetDirectoryResults());
        redirectWithParams(__assign(__assign({}, defaultParams), { state: querystate, isFile: queryFile, sortOrder: queryOrder, isEmail: queryEmail }), history);
    }, [queryEmail]);
    var onClearQuery = function () {
        setPendingQuery('');
    };
    /** Redirect when page number changes. */
    var changePageHandler = function (_, pageNumber) {
        redirectWithParams(__assign(__assign({}, params), { state: querystate, isFile: queryFile, sortOrder: queryOrder, isEmail: queryEmail, currentPage: pageNumber }), history);
    };
    /** Redirect when rows per page changes. */
    var changeRowsPerPageHandler = function (event) {
        redirectWithParams(__assign(__assign({}, params), { state: querystate, isFile: queryFile, sortOrder: queryOrder, isEmail: queryEmail, currentPage: 0, rowsPerPage: parseInt(event.target.value, 10) }), history);
    };
    var queryToDisplay = (queryForResult || '').trim();
    // detect changes in query
    (0, react_1.useEffect)(function () {
        if (!query) {
            return;
        }
        setPendingQuery(query);
        getResults();
    }, [query, sortOrder, rowsPerPage, currentPage, state, isFile, isEmail]);
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(BaseLayout_1.default, { headerBackgroundType: "darkest", hideNavButtons: false },
            react_1.default.createElement(DirectoryHeader_1.default, { onQueryChange: onQueryChange, query: pendingQuery, onSortOrderChange: setQueryOrder, onClearQuery: onClearQuery, getFile: setQueryFile, getState: setQueryState, getEmail: setQueryEmail, onApply: applyChanges, onReset: onResetFilter, setDisablePagination: setDisablePagination }),
            queryToDisplay ? (react_1.default.createElement(DirectoryResults_1.default, { searchResults: searchResults, pageCount: pageCount, rowsPerPage: rowsPerPage, currentPage: currentPage, changePageHandler: changePageHandler, changeRowsPerPageHandler: changeRowsPerPageHandler, resultsCount: resultsCount, query: queryToDisplay, disablePagination: disablePagination, rankOffset: rankOffset })) : (react_1.default.createElement(EmptySearchGraphic_1.default, null)))));
};
exports.default = SearchPage;
